import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Container, ListGroup, ListGroupItem } from "reactstrap";
import { getAdsList, deleteAd } from "../../store/actions/ads";
import { MdAddCircle } from "react-icons/md";
import { getAllChannels } from "../../store/actions/channels";
import AdRow from "../../components/Ads/AdRow";
import Typeahead from "../../components/Form/Typeahead";
import Channel from "../../components/Channels/Channel";
import { getAdsListRequest } from "../../requests/ads";



const AdsList = props => {
  const [selectedChannel, setSelectedChannel] = useState();
  const [adsByChannel, setAdsByChannel] = useState();
  useEffect(() => {
    if (!props.loadingAds) props.getAdsList();
    if (!Object.keys(props.channels).length && !props.loadingChannels) {
      props.getAllChannels();
    }
  }, [])
  return (
    <Container fluid>
      <div className="d-flex align-items-center mb-4">
        <h4 className="m-0">تبلیغات</h4>
        <div className="flex-grow-1 mr-3 ml-3" style={{ marginBottom: '-1em' }}>
          <Typeahead
            id="search-channels"
            options={Object.values(props.channels)}
            labelKey="name"
            promptText="برای جستجو شروع به نوشتن کنید"
            placeholder="فیلتر کردن تبلیغات با کانال"
            emptyLabel="کانالی پیدا نشد"
            paginationText="نمایش کانال‌های بیشتر"
            clearButton
            renderMenuItemChildren={result => (<Channel channel={result} noLink coverSize={40} className="p-0 mb-2" />)}
            onChange={selected => {
              if (selected && selected.length) {
                setSelectedChannel(selected[0]);
                getAdsListRequest(selected[0].id)
                  .then(response => {
                    setAdsByChannel(response.data);
                  })
                  .catch(err => console.log(err))
              } else {
                setSelectedChannel(null);
              }
            }}
          />
        </div>
        <div>
          <Link to="/ads/new" className="btn btn-primary has-icon">
            <MdAddCircle className="ml-2" />
            افزودن تبلیغ
          </Link>
        </div>
      </div>
      {props.ads &&
        <ListGroup flush>
          {!selectedChannel && Object.values(props.ads).sort((a, b) => { return b.id - a.id }).map(ad => (
            <ListGroupItem action key={ad.id} className="p-0">
              <AdRow
                data={ad}
                onDelete={() => props.deleteAd(ad)}
                disabled={ad.id === props.loadingAd}
              />
            </ListGroupItem>
          ))}
          {adsByChannel && adsByChannel.map(ad => (
            <ListGroupItem action key={ad.id} className="p-0">
              <AdRow
                data={ad}
                onDelete={() => props.deleteAd(ad)}
                disabled={ad.id === props.loadingAd.id}
              />
            </ListGroupItem>
          ))}
          {selectedChannel && adsByChannel && !adsByChannel.length &&
            <p className="text-center p-4">تبلیغی برای این کانال یافت نشد</p>
          }
          {
            !props.ads && !props.loadingAds &&
            <p className="text-center p-4">تبلیغی وجود ندارد</p>
          }
        </ListGroup>
      }
    </Container>
  )
}


export default connect(
  state => (
    {
      ads: state.ads.list,
      loadingAd: state.loading.ad,
      loadingAds: state.loading.ads,
      loadingChannels: state.loading.channels,
      channels: state.channels
    }
  ),
  dispatch => bindActionCreators({
    getAdsList,
    getAllChannels,
    deleteAd
  }, dispatch)
)(AdsList)